module.exports = __webpack_public_path__ + "img/肌如初雪套装_07.987f52ab.jpg";